import {VWCarModel} from '../types/surveyResponse';

export const getMoreAboutEvRangeLink = (model: VWCarModel | undefined) => {
  if (!model) return '';

  const MORE_ABOUT_EV_RANGE_PATHS: Record<VWCarModel, string> = {
    id4: '/models/id4.html',
    id4gtx: '/models/id4-gtx.html',
    id5: '/models/id5.html',
    id5gtx: '/models/id5-gtx.html',
    idBuzz5: '/models/id-buzz.html',
    idBuzz7: '/models/id-buzz.html',
    idBuzzCargo: '/models/id-buzz.html',
    touareg: '/range/volkswagen-r.html',
    amarok: '/models/amarok.html',
    id4Andid5: '/hybrid-and-electric/id-range.html',
    id4gtxAndid5gtx: '/hybrid-and-electric/id-range.html',
  };

  return `https://www.volkswagen.com.au/en${MORE_ABOUT_EV_RANGE_PATHS[model]}`;
};
